import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiEndpoints } from '../../constants';
import {
  ICountry,
  ICreteReferralBody,
  IDeclineReferralBody,
} from '../../types';
import { formatErrorMessage } from '../../utils';
import { notificationAlert } from '../notifications';
import { referFriendStoreKey } from './referFriend.const';
import { IReferrer } from 'src/types';

export const fetchReferrerProfile = createAsyncThunk(
  `${referFriendStoreKey}/fetchReferrerProfile`,
  async (_, thunkAPI) => {
    try {
      const response = await axios.get<IReferrer>(
        apiEndpoints.fetchReferrerProfilePath(),
      );

      return response.data;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const loginReferrer = createAsyncThunk(
  `${referFriendStoreKey}/loginReferrer`,
  async (
    body: { email?: string; googleToken?: string; emailToken?: string },
    thunkAPI,
  ) => {
    try {
      const response = await axios.post<{ isEmailSent: boolean }>(
        apiEndpoints.loginReferralPath(),
        body,
      );

      if (!response.data.isEmailSent) {
        await thunkAPI.dispatch(fetchReferrerProfile());
      }

      return response.data;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }

      thunkAPI.dispatch(
        notificationAlert(formatErrorMessage(err), { variant: 'error' }),
      );

      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const fetchReferrerCountryOptions = createAsyncThunk(
  `${referFriendStoreKey}/fetchReferrerCountryOptions`,
  async (_, thunkAPI) => {
    try {
      const response = await axios.get<ICountry[]>(
        apiEndpoints.getCountriesPath(),
      );

      return response.data;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const submitReferral = createAsyncThunk(
  `${referFriendStoreKey}/submitReferral`,
  async (body: ICreteReferralBody, thunkAPI) => {
    try {
      const response = await axios.post(
        apiEndpoints.submitReferralPath(),
        body,
      );

      return response.data;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(formatErrorMessage(err), { variant: 'error' }),
      );

      if (!err.response) {
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const declineReferral = createAsyncThunk(
  `${referFriendStoreKey}/declineReferral`,
  async (body: IDeclineReferralBody, thunkAPI) => {
    try {
      const response = await axios.post(
        apiEndpoints.declineReferralPath(),
        body,
      );

      return response.data;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(formatErrorMessage(err), { variant: 'error' }),
      );

      return thunkAPI.rejectWithValue(err);
    }
  },
);
